import React, {useState, useEffect} from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { NavLink } from "react-router-dom";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";

import Searchbar from "components/Navbars/Searchbar";

import {useCookies } from 'react-cookie';

import { API_URI } from '../../helpers';

// Helpers para fechas (mismo estilo que Dashboard)
const formatDateISO = (date) => date.toISOString().split("T")[0];
const getDateRange = (preset) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const to = formatDateISO(today);

  switch (preset) {
    case "today": {
      return { from: to, to };
    }
    case "yesterday": {
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      return { from: formatDateISO(yesterday), to: formatDateISO(yesterday) };
    }
    case "7d": {
      const from = new Date(today);
      from.setDate(from.getDate() - 6);
      return { from: formatDateISO(from), to };
    }
    case "14d": {
      const from = new Date(today);
      from.setDate(from.getDate() - 13);
      return { from: formatDateISO(from), to };
    }
    case "30d": {
      const from = new Date(today);
      from.setDate(from.getDate() - 29);
      return { from: formatDateISO(from), to };
    }
    case "mtd": {
      const from = new Date(today.getFullYear(), today.getMonth(), 1);
      return { from: formatDateISO(from), to };
    }
    case "year": {
      const from = new Date(today);
      from.setDate(from.getDate() - 364);
      return { from: formatDateISO(from), to };
    }
    default:
      return { from: undefined, to: undefined };
  }
};

const DATE_PRESETS = [
  { key: "today", label: "Hoy" },
  { key: "yesterday", label: "Ayer" },
  { key: "7d", label: "7 días" },
  { key: "14d", label: "14 días" },
  { key: "30d", label: "30 días" },
  { key: "mtd", label: "Este mes" },
  { key: "year", label: "Último año" },
  { key: "custom", label: "Personalizado" },
];

// Función para formatear fecha con timezone Argentina (UTC-3)
const formatDateTimeAR = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  // Ajustar a Argentina (UTC-3)
  const options = {
    timeZone: 'America/Argentina/Buenos_Aires',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  };
  return date.toLocaleString('es-AR', options);
};

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Rubik','Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};

export default function ListStudents() {
  const [tableData, setTableData] =  useState({
    headers:[
      {name:"Fecha",type:"text",sortable:'created_at'},
      {name:"Pais",type:"text",sortable:'country'},
      {name:"Nombre",type:"text",sortable:'student.name'},
      {name:"Apellido",type:"text",sortable:'student.lastname'},
      {name:"Mail",type:"text",sortable:'student.mail'},
      {name:"Precio Local",type:"text",sortable:'price',align:"right"},
      {name:"Precio USD",type:"text",sortable:'price_usd',align:"right"},
      {name:"Renovación",type:"text",sortable:'price_usd',align:"right"}
    ],
    data:[],
    sorting:{},
    pagination:null
  });
  const [countriesTableData, setCountriesTableData] =  useState({
    headers:[
      {name:"Pais",type:"text",sortable:'created_at'},
      {name:"Total USD",type:"text",sortable:'country'},
      {name:"Cantidad Ventas",type:"text",sortable:'student.name'}
    ],
    data:[]
  });
  const [cookies, setCookie, removeCookie] = useCookies();

  // Nuevo sistema de fechas
  const [activePreset, setActivePreset] = useState("today");
  const defaultRange = getDateRange("today");
  const [startDate, setStartDate] = useState(defaultRange.from);
  const [endDate, setEndDate] = useState(defaultRange.to);

  const [globalValues, setGlobalValues] = useState({
    totalPrice: null,
    totalSales: null
  });
  const [downloading, setDownloading] = useState("");

  // Descarga las ventas del período activo en CSV o Excel.
  function download(format) {
    const body = new FormData();
    if (startDate) body.append("startDate", startDate);
    if (endDate) body.append("endDate", endDate);
    body.append("format", format);

    setDownloading(format);
    fetch(`${API_URI}/admin/suscriptions/export`, { method: "POST", body })
      .then(async (r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.blob();
      })
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        const stamp = formatDateISO(new Date());
        a.href = url;
        a.download = `ventas_${stamp}.${format === "xls" ? "xls" : "csv"}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      })
      .catch(() => {})
      .finally(() => setDownloading(""));
  }

  // Cambiar preset
  const handlePresetChange = (preset) => {
    setActivePreset(preset);
    if (preset !== "custom") {
      const range = getDateRange(preset);
      setStartDate(range.from);
      setEndDate(range.to);
    }
  };

  useEffect(() => {
    getListado();
  }, [startDate, endDate]);

  function getListado(params = null){
    const extra = new FormData();
    let srh = (cookies.suscriptions_list && cookies.suscriptions_list.search)?cookies.suscriptions_list.search:null;
    const sort = (cookies.suscriptions_list && cookies.suscriptions_list.sorting)?cookies.suscriptions_list.sorting:null;
    let reset = false;
      if(params && params.field){
        extra.append('order',params.field);
        extra.append('direc',params.dir)
        reset = true;
      }else if(sort && sort.field){
        extra.append('order',sort.field);
        extra.append('direc',sort.dir)
      }
      
      if(params && params.search && params.search!=""){        
        extra.append('search',params.search);
        reset = true;
      }else if((!params || !('search' in params)) && srh){
        extra.append('search',srh);
      }else{
        if(!params){
          params = {}
        }else if(params.search == ""){
          reset = true;
        }
        params.search = srh = null;
      }
      if (startDate) {
        extra.append('startDate', startDate);
      }
      if (endDate) {
        extra.append('endDate', endDate);
      }
      if(params && params.page){
        extra.append('page',params.page);
      }else if(!reset && cookies.suscriptions_list){     
        extra.append('page',cookies.suscriptions_list.paginate.current);
      }
      
    fetch(`${API_URI}/admin/suscriptions`,{method:'POST',body:extra})
    .then(res => res.json())
    .then(
      (result) => {
        const data = [];
        result.subscriptions.data.forEach(function(v,k){
          var items = [
              {name: formatDateTimeAR(v.created_at), type:'text'},
              {name:v.country.name,type:'text'},
              {name:(v.student)?v.student.name:"",type:'text'},
              {name:(v.student)?v.student.lastname:"",type:'text'},
              {name:(v.student)?v.student.mail:"",type:'text'},
              {name:v.price,type:'text',align:"right"},
              {name:v.price_usd,type:'text',align:"right"},
              {name:v.subscription_id != null ? "Si" : "No",type:'text',align:"right"},
            ]
          data.push(items);
        })

        const countriesSumData = [];
        result.countriesSum.forEach(function(v,k){
          var items = [
              {name:v.name,type:'text'},
              {name:v.price,type:'text'},
              {name:v.count,type:'text'},
            ]
            countriesSumData.push(items);
        })

        globalValues.totalPrice = result.totalPrice;
        globalValues.totalSales = result.totalSales;
        setGlobalValues(globalValues);

        const paginate = {'current':result.subscriptions.current_page,'next':result.subscriptions.next_page_url,'prev':result.subscriptions.prev_page_url,'total':result.subscriptions.last_page};
        setTableData({
          ...tableData,
          ['data']:data,
          ['pagination'] : {'current':result.subscriptions.current_page,'next':result.subscriptions.next_page_url,'prev':result.subscriptions.prev_page_url,'total':result.subscriptions.last_page},
          ['sorting']:(params && params.field)?{'field':params.field,'dir':params.dir}:sort,
          ['search'] : (params && params.search)?params.search:srh,
        })

        setCountriesTableData({
          ...countriesTableData,
          ['data']:countriesSumData,
          ['sorting']:(params && params.field)?{'field':params.field,'dir':params.dir}:sort,
          ['search'] : (params && params.search)?params.search:srh,
        })

        setCookie('suscriptions_list',{
          'paginate':paginate,
          'sorting':(params && params.field)?{'field':params.field,'dir':params.dir}:sort,
          'search':(params && params.search)?params.search:srh,
        })
      })
  }
  
  function ordering(field,dir){
    const obj = {field:field,dir:dir}
    setTableData({
      ...tableData,
      ['data']:[],
      ['sorting']:obj
    })
    getListado(obj);
  }

  // Estilos para los botones de preset
  const presetButtonStyle = (isActive) => ({
    padding: "8px 16px",
    border: "none",
    borderRadius: 8,
    fontSize: 13,
    fontWeight: isActive ? 600 : 400,
    cursor: "pointer",
    background: isActive ? "#3B82F6" : "#F3F4F6",
    color: isActive ? "#FFFFFF" : "#374151",
    transition: "all 0.2s ease",
    whiteSpace: "nowrap",
  });
  
  return (
    <GridContainer>
      {/* Filtro de fechas moderno */}
      <GridItem xs={12} sm={12} md={12}>
        <Card style={{ marginBottom: 16 }}>
          <CardBody style={{ padding: "16px 20px" }}>
            <div style={{ 
              display: "flex", 
              flexWrap: "wrap",
              alignItems: "center", 
              gap: 12
            }}>
              <span style={{ fontWeight: 600, color: "#374151", marginRight: 8 }}>
                Período:
              </span>
              {DATE_PRESETS.map((preset) => (
                <button
                  key={preset.key}
                  onClick={() => handlePresetChange(preset.key)}
                  style={presetButtonStyle(activePreset === preset.key)}
                >
                  {preset.label}
                </button>
              ))}
              
              {activePreset === "custom" && (
                <div style={{ display: "flex", gap: 8, alignItems: "center", marginLeft: 16 }}>
                  <input
                    type="date"
                    value={startDate || ""}
                    onChange={(e) => setStartDate(e.target.value)}
                    style={{
                      padding: "8px 12px",
                      border: "1px solid #D1D5DB",
                      borderRadius: 8,
                      fontSize: 13,
                    }}
                  />
                  <span style={{ color: "#6B7280" }}>→</span>
                  <input
                    type="date"
                    value={endDate || ""}
                    onChange={(e) => setEndDate(e.target.value)}
                    style={{
                      padding: "8px 12px",
                      border: "1px solid #D1D5DB",
                      borderRadius: 8,
                      fontSize: 13,
                    }}
                  />
                </div>
              )}
              
              {activePreset !== "custom" && startDate && (
                <span style={{
                  fontSize: 12,
                  color: "#6B7280",
                  marginLeft: 8,
                  background: "#F9FAFB",
                  padding: "4px 10px",
                  borderRadius: 6
                }}>
                  {startDate === endDate ? startDate : `${startDate} → ${endDate}`}
                </span>
              )}

              <span style={{ flex: 1 }} />

              <button
                type="button"
                onClick={() => download("csv")}
                disabled={!!downloading}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  padding: "8px 14px",
                  borderRadius: 8,
                  fontSize: 13,
                  fontWeight: 600,
                  border: "1px solid #D1D5DB",
                  background: "#fff",
                  color: "#374151",
                  cursor: downloading ? "default" : "pointer",
                  opacity: downloading ? 0.6 : 1,
                }}
              >
                <span className="material-icons" style={{ fontSize: 18 }}>download</span>
                {downloading === "csv" ? "Generando…" : "CSV"}
              </button>
              <button
                type="button"
                onClick={() => download("xls")}
                disabled={!!downloading}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  padding: "8px 14px",
                  borderRadius: 8,
                  fontSize: 13,
                  fontWeight: 600,
                  border: "1px solid #D1D5DB",
                  background: "#fff",
                  color: "#374151",
                  cursor: downloading ? "default" : "pointer",
                  opacity: downloading ? 0.6 : 1,
                }}
              >
                <span className="material-icons" style={{ fontSize: 18 }}>download</span>
                {downloading === "xls" ? "Generando…" : "Excel"}
              </button>
            </div>
          </CardBody>
        </Card>
      </GridItem>

      <GridItem xs={12} sm={12} md={12}>
        {/* KPIs de resumen */}
        { globalValues.totalPrice && globalValues.totalSales ? 
          <Card style={{ marginBottom: 16 }}>
            <CardBody style={{ padding: "20px" }}>
              <div style={{ 
                display: "grid", 
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", 
                gap: 24 
              }}>
                <div style={{ 
                  padding: "16px 20px", 
                  background: "#DCFCE7", 
                  borderRadius: 12,
                  borderLeft: "4px solid #10B981"
                }}>
                  <div style={{ fontSize: 12, color: "#166534", fontWeight: 500, marginBottom: 4 }}>
                    Total Ventas
                  </div>
                  <div style={{ fontSize: 24, fontWeight: 700, color: "#059669" }}>
                    USD {globalValues.totalPrice.toLocaleString()}
                  </div>
                </div>
                
                <div style={{ 
                  padding: "16px 20px", 
                  background: "#EFF6FF", 
                  borderRadius: 12,
                  borderLeft: "4px solid #3B82F6"
                }}>
                  <div style={{ fontSize: 12, color: "#1E40AF", fontWeight: 500, marginBottom: 4 }}>
                    Cantidad Ventas
                  </div>
                  <div style={{ fontSize: 24, fontWeight: 700, color: "#2563EB" }}>
                    {globalValues.totalSales.toLocaleString()}
                  </div>
                </div>
                
                <div style={{ 
                  padding: "16px 20px", 
                  background: "#FEF3C7", 
                  borderRadius: 12,
                  borderLeft: "4px solid #F59E0B"
                }}>
                  <div style={{ fontSize: 12, color: "#92400E", fontWeight: 500, marginBottom: 4 }}>
                    Precio Promedio
                  </div>
                  <div style={{ fontSize: 24, fontWeight: 700, color: "#D97706" }}>
                    USD {Math.round(globalValues.totalPrice/globalValues.totalSales).toLocaleString()}
                  </div>
                </div>
              </div>
            </CardBody>
          </Card> : null }

        <Card>
          <CardBody>
            <Table
              tableHeaderColor="info"
              tableHead={tableData.headers}
              tableData={tableData.data}
              sortered={tableData.sorting}
              sortCallback={ordering}
              paginate={getListado}
              dtaPage = {tableData.pagination}
            />
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <Table
              tableHeaderColor="info"
              tableHead={countriesTableData.headers}
              tableData={countriesTableData.data}
              sortCallback={ordering}
              paginate={getListado}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
   
  );
}
